import * as React from "react";

const IconNavRightDark: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="currentColor"><polygon fill="#666" points="6.497 5.499 6.013 5.981 1.454 10.518 .969 11 .003 10.036 .488 9.554 4.564 5.499 .485 1.443 0 .961 .969 0 1.454 .482 6.015 5.016 6.5 5.499"/></svg>;
};

export default React.memo(IconNavRightDark);
